export enum SemanaMes {
  SEMANA_1 = 1,
  SEMANA_2,
  SEMANA_3,
  SEMANA_4,
  SEMANA_5,
}

export interface Semana {
  id: SemanaMes;
  nome: string;
}

export const SEMANAS: Semana[] = Object.values(SemanaMes)
  .filter((v) => typeof v === 'number')
  .map((id) => ({
    id: id as SemanaMes,
    nome: `Semana ${id}`,
  }));
